export var BAidType;
(function (BAidType) {
    BAidType[BAidType["ICTAndFixedAssets"] = 41] = "ICTAndFixedAssets";
    BAidType[BAidType["PremisesRenovationOrImprovement"] = 42] = "PremisesRenovationOrImprovement";
    BAidType[BAidType["SupportApartments"] = 43] = "SupportApartments";
})(BAidType || (BAidType = {}));
